import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const InfoBox = ({ municipio }) => {
  const { img, etapa, nombreUrl, tipoVotacion } = municipio;

  var votacionSubtitulo =
    tipoVotacion === "publica"
      ? "Completá el formulario haciendo click en el botón."
      : "Enterate de cómo y cuándo votar las propuestas presentadas.";

  const obtenerTexto = {
    informativa: {
      titulo: "¡Pronto tendremos novedades!",
      subtitulo: "",
    },
    presentacion: {
      titulo: "¡Sumá tus propuestas!",
      subtitulo: "Completá el formulario haciendo click en el botón.",
    },
    votacion: {
      titulo: "¡Votá!",
      subtitulo: votacionSubtitulo,
    },
    seleccion: {
      titulo: "¡Proyectos seleccionados!",
      subtitulo: "Enterate de cuáles son y seguí su ejecución.",
    },
  };

  const obtenerAccion = () => {
    // Si nombreUrl es 'laboulaye2024', redirigir a votacion externa
    if (nombreUrl === "laboulaye2024" && etapa === "votacion") {
      return (
        <p>
          <a
            href="https://munidigital.com/citizenv2/laboulaye/presupuesto-participativo"
            className="btn btn-lg ppr-btn-verde font-weight-bold"
            target="_blank" // Para abrir en una nueva pestaña
            rel="noopener noreferrer"
          >
            FORMULARIO
          </a>
        </p>
      );
    }

    const urls = { presentacion: "presentacion", votacion: "votacion/0" };
    if (
      etapa === "presentacion" ||
      (etapa === "votacion" && tipoVotacion === "publica")
    ) {
      return (
        <p>
          <Link
            to={`/municipio/${nombreUrl}/${urls[etapa]}`}
            className="btn btn-lg ppr-btn-verde font-weight-bold"
          >
            FORMULARIO
          </Link>
        </p>
      );
    }
    return null;
  };

  return (
    <Fragment>
      <section
        className="infobox-img"
        style={{
          background: `url(/img/mun_img/${img}) no-repeat center center /cover fixed`,
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-5 d-table">
              <div className="infobox card card-body d-table-cell align-middle">
                <h1>{obtenerTexto[etapa]["titulo"]}</h1>
                <p> {obtenerTexto[etapa]["subtitulo"]}</p>
                <div className="text-center">{obtenerAccion(etapa)}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default InfoBox;
